import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import Text from 'src/components/ui/Text'
import { useLocalePath } from 'src/utils/router/route'
import { useHash } from 'src/utils/router/useHash'
import { track } from 'src/utils/tracker'
import { SearchForm } from '../SearchForm'

export default function ModelSearchForm({
  keyword: keywordProp,
}: {
  keyword?: string
}) {
  const localePath = useLocalePath()
  const [hash] = useHash()
  const hashParams = new URLSearchParams(hash.replace(/^#/, ''))
  const keyword = keywordProp ?? hashParams.get('keyword') ?? ''
  const { t } = useTranslation(['market', 'common'])
  const navigate = useNavigate()

  return (
    <SearchForm
      keyword={keyword}
      placeholder={t('market:search.search-placeholder')}
      onSubmit={value => {
        if (!value) return
        const params = new URLSearchParams(hash.replace(/^#/, ''))
        params.set('keyword', value)
        track('search', {
          value,
          type: hashParams.get('type') ?? undefined,
          scene: 'market',
        })
        navigate(localePath(`/market#${params.toString()}`))
      }}
      button="separated"
      scene="market"
      className="grid grid-cols-[minmax(max-content,1fr)_minmax(200px,500px)_minmax(max-content,1fr)] justify-center items-center gap-2"
      prepend={
        <h1 className="justify-self-end px-2 font-bold text-2xl">
          <span
            className="block whitespace-nowrap"
            style={{ transform: 'translateY(2px)' }}
          >
            <Text i18nKey="common:market.long-label" />
          </span>
        </h1>
      }
    />
  )
}
